import 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.min.css';

import 'select2/dist/js/select2.full';
import '@cm/styles/devise.scss';
import '@cm/styles/devise-signup.scss';
